/**
 * Avalara © 2018
 * file: engines/opus_ui/src/search/BusinessActivity.js
 */

import React from 'react';

const BusinessActivity = (data) => {
  return (
    <div className="ResultsSection">
      <div>Actual Business Activity Results</div>
    </div>
  );
};

export default BusinessActivity;
